import { render, staticRenderFns } from "./userMeansInfo.vue?vue&type=template&id=490005b8&scoped=true&"
import script from "./userMeansInfo.vue?vue&type=script&lang=js&"
export * from "./userMeansInfo.vue?vue&type=script&lang=js&"
import style0 from "./userMeansInfo.vue?vue&type=style&index=0&id=490005b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490005b8",
  null
  
)

export default component.exports